export default (firstString, secondString) => firstString.trim().toLowerCase().includes(secondString.trim().toLowerCase())
